var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213 197.5",
    style: {
      enableBackground: "new 0 0 213 197.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5AB9E5;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,20h122.6v59.2c0,0.8,0,1.5,0,2.3c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.4-0.1-0.6-0.2c-1.4-0.7-2.7-1.6-4.1-2.2 c-0.6-0.2-1-0.8-1-1.4c0-17,0-34.1,0-51.1v-1.2H29.9v139.5c0.4,0,0.7,0,1.1,0c36.2,0,72.3,0,108.5,0c1,0,1.3-0.2,1.3-1.2 c-0.1-4.6,0-9.2,0-13.8c-0.1-0.5,0.2-1,0.6-1.2c1.5-0.7,3-1.5,4.5-2.3c0.2,0,0.3-0.1,0.5-0.1c0,0.3,0.1,0.6,0.1,0.9 c0,7.4,0,14.9,0,22.3c0,0.6-0.2,0.9-0.8,0.8c-0.3,0-0.5,0-0.8,0H24.1L24,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.3,134.3c2.3,2.3,4.6,4.6,6.9,6.9c0.3,0.1,0.7,0.1,1,0c4.1-1.8,7-1.3,10.2,1.8l23.2,23.2 c1.5,1.5,2.6,3.4,2.4,5.6c-0.1,1.3-0.5,2.5-1.1,3.6c-1.6,2.9-3.6,5.6-7.1,6.5c-2.7,0.7-5.3,0.4-7.4-1.6 c-7.8-7.7-15.5-15.6-23.2-23.4c-1.5-1.3-2.5-3-3-4.9c-0.4-1.8-0.1-3.6,0.7-5.3c0.3-0.5,0.2-1.2-0.2-1.5c-2.1-2.2-4.2-4.4-6.3-6.6 c-8.1,6.4-17.1,8.7-27,6.5c-7.4-1.6-13.8-5.9-18.2-12c-10.1-13.9-7-33.4,6.9-43.4s33.4-7,43.4,6.9 C164.6,107.8,164.2,123.4,155.3,134.3L155.3,134.3z M130.7,139.6c14,0,25.3-11.3,25.3-25.3c0-14-11.3-25.3-25.3-25.3 c-13.9,0-25.3,11.3-25.3,25.2C105.5,128.2,116.8,139.6,130.7,139.6C130.7,139.6,130.7,139.6,130.7,139.6z M188.6,176.8 c0.6-0.2,1.2-0.5,1.8-0.9c0.9-0.8,1.6-1.8,2.3-2.8c0.8-1.3,0.7-1.9-0.4-3l-16.7-16.7c-2.2-2.2-4.4-4.4-6.6-6.6 c-0.6-0.8-1.8-1.1-2.7-0.6c-0.8,0.4-1.6,0.9-2.4,1.6c-1.8,1.7-1.8,3-0.2,4.8c0.2,0.2,0.4,0.4,0.5,0.6c7.5,7.6,15,15.1,22.5,22.7 C187.4,176.2,188,176.5,188.6,176.8L188.6,176.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,88.4h47.9v5.3H46.2V88.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,110.4c0-1.6,0-3.2,0-4.7c0-0.2,0.4-0.5,0.6-0.6s0.4,0,0.6,0h46.8v5.4L46.2,110.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,126.8v-5.3h47.9v5.3H46.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,143.5v-5.3h47.9v5.3H46.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,42.6h5.7v30.1h-5.7V42.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.8,50.2h5.7v22.4h-5.7V50.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.1,72.6h-5.8V52.4h5.8V72.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.4,57.4h5.7v15.2h-5.7V57.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,72.6V58.9h5.8v13.6H45.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,72.6h-5.7V61.8H81V72.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,112.4c0.2,0.2,0.5,0.4,0.7,0.6c1.9,1.9,3.9,3.9,5.8,5.9c0.6,0.6,0.9,0.6,1.5,0c5-5,10.1-9.9,15.2-14.9 c0.6-0.6,1-0.7,1.6,0c0.7,0.8,1.5,1.5,2.4,2.2c0.7,0.5,0.6,0.8,0,1.4c-5.9,5.8-11.7,11.6-17.5,17.5c-0.6,0.6-1.3,1.3-1.9,2 c-0.4,0.4-0.7,0.5-1.1,0c-3.4-3.4-6.8-6.8-10.2-10.2c-0.3-0.3-0.4-0.6,0-1c1-1,2-2,3.1-3.1C118.7,112.6,118.8,112.5,119,112.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportes);
export default __webpack_public_path__ + "static/media/reportes.98bfc06f667200761b44e3be87febe82.svg";
export { ForwardRef as ReactComponent };